import React from "react";
import { Box, Container, Typography, useTheme, useMediaQuery } from "@mui/material";

// Local imports for partner logos
import awsLogo from "../../logoimage/partner-2.png";
import microsoftLogo from "../../logoimage/partner-1.png";
import googleCloudLogo from "../../logoimage/partner-3.png";
import ibmLogo from "../../logoimage/partner-5.png";
import oracleLogo from "../../logoimage/partner-6.png";
import salesforceLogo from "../../logoimage/partner-8.png";
import adobeLogo from "../../logoimage/partner-9.png";
import intelLogo from "../../logoimage/partner-14.png";

const PartnerLogosSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const partners = [
    { name: "Amazon Web Services", logo: awsLogo },
    { name: "Microsoft", logo: microsoftLogo },
    { name: "Google Cloud", logo: googleCloudLogo },
    { name: "IBM", logo: ibmLogo },
    { name: "Oracle", logo: oracleLogo },
    { name: "Salesforce", logo: salesforceLogo },
    { name: "Adobe", logo: adobeLogo },
    { name: "Intel", logo: intelLogo },
  ];

  const allPartners = [...partners, ...partners];

  return (
    <Box
      component="section"
      sx={{
        borderColor: 'divider',
        maxWidth: '1200px',
        margin: '0 auto',
        overflow: 'hidden',
      }}
    >
      <Container 
        maxWidth={false} 
        sx={{
          maxWidth: '1024px',
          margin: '0 auto',
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Typography
          variant="h3"
          component="h2"
          align="center"
          sx={{
            fontSize: { xs: '20px', sm: '22px', md: '27px' },
            fontWeight: 700,
            color: '#000',
            mb: { xs: 4, md: 6 },
            lineHeight: 1.3,
            maxWidth: '800px',
            mx: 'auto'
          }}
        >
          Partnering with the world's{" "}
          <span style={{ color: '#1b8985', fontWeight: 700 }}>
            leading universities and companies
          </span>
        </Typography>

        {/* Logo Slider / Grid */}
        {!isMobile ? (
          <Box
            className="logo-slider"
            sx={{
              display: 'flex',
              gap: { xs: 3, md: 4, lg: 5 },
              animation: 'scroll 40s linear infinite',
            }}
          >
            {allPartners.map((partner, index) => (
              <Box
                key={index}
                sx={{
                  flexShrink: 0,
                  width: { xs: 120, sm: 140, md: 160, lg: 180 },
                  height: { xs: 40, sm: 70, md: 80 },
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: 2,
                }}
              >
                <Box component="img" src={partner.logo} alt={partner.name} sx={{ maxWidth: '64%', maxHeight: '68%', objectFit: 'contain' }} />
              </Box>
            ))}
          </Box>
        ) : (
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: 2,
              justifyItems: 'center',
            }}
          >
            {partners.map((partner, index) => (
              <Box
                key={index}
                sx={{
                  width: 120,
                  height: 54,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: 2,
                  p: 1,
                }}
              >
                <Box component="img" src={partner.logo} alt={partner.name} sx={{ maxWidth: '64%', maxHeight: '68%', objectFit: 'contain' }} />
              </Box>
            ))}
          </Box>
        )}
      </Container>

      <style jsx global>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(calc(-1 * (160px + 20px) * ${partners.length})); }
        }
      `}</style>
    </Box>
  );
};

export default PartnerLogosSection;